<template>
  <div id="stock-in">
    <b-card>
      <b-row>
        <b-col md="6">
          <h3>{{$route.name}}</h3>
          <!-- breadcrumb -->
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/inventory/stock-item-list">Stock Item List</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <!-- end breadcrumb -->
        </b-col>
      </b-row>
      <div v-if="isLoading" style="position: relative;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else></div>
      
       
           <b-button class="mt-3 mb-3" :to="'/inventory/stock-item-list'" variant="secondary"
              ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
            >
            <!-- <b-button
              class="mt-3 mb-5 float-right"
              :to="'/inventory/stock-in/' + $route.params.uuid + '/edit'"
              variant="warning"
              ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
            > -->
    </b-card>
  </div>
</template>
<script>
export default {
  data(){
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],

      apiUrl:{
        stockItemData: window.AppConfig.apiUrl + 'stock-item-data',

      },
      fields: [
        {
          key: 'itemList',
          label: 'Item Name',
          class: 'break-text'
        },
        {
          key: 'stockInItemQuantity',
          label: 'Quantity'
        },
        {
          key: 'stockInItemPrice',
          label: 'Price/Unit'
        },
        {
          key: 'stockInItemCogs',
          label: 'Cost Of Goods Sold'
        },
        {
          key: 'stockInItemNote',
          label: 'Description'
        }
      ],
      model:{
        stockInId: null,
        stockInDate: null,
        stockInNote: null,
        stockArea: null,
        stockAddress: null,
        areaCode: null,
        journalAccount: null,
        stockInItem: null,
        stockInItemNote: null,
        stockInItemQuantity: null,
        stockInItemPrice: null,
        itemList: null,
        stockIn: null,
        createdBy: {
          branch: null,
          firstName: null,
          lastName: null
        },
        createdAt: null,
        updatedAt: null,
        changedBy:{
          branch: null,
          firstName: null,
          lastName: null
        },
        items: []
      }
    }
  },

  mounted(){
    this.initData()
  },

  methods: {
    initData(){
      if(this.$route.params.uuid !== undefined){
        this.getDetail()
      }
    },

     formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    async getDetail(){
      const {resp} = await this.$http.get(this.apiUrl.stockItemData + '/' + this.$route.params.uuid)
      console.log("data is", resp);
    }
  }
}
</script>

<style scoped>
.break-text{
  white-space: pre-line !important;
}
</style>